import { render } from "./App.vue?vue&type=template&id=2c90de5a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2c90de5a&lang=scss"
script.render = render

export default script